export default class PhotoError extends Error {

  name = "PhotoError";

  constructor(message, code) {
    super(message);
    this.code = code;
  }

  static CODE_INVALID_FORMAT = "invalid_format";
  static CODE_FILES_AMOUNT = "files_amount";

  static invalidFormat(format) {
    return new PhotoError(`Unsupported file format: ${format}`, PhotoError.CODE_INVALID_FORMAT);
  }

  static filesAmount(passed, required) {
    return new PhotoError(`Invalid files amount (required ${required}, passed ${passed})`, PhotoError.CODE_FILES_AMOUNT);
  }
}
